import React, { useCallback } from 'react'
import t from '~t'
import { getDomain } from '~modules/format/url'

import { Alert, Wrap, Item, ItemIcon, ItemTitle, ItemActions, Label, Icon, Button } from '~ui';
import Cover from '~co/bookmarks/item/cover'

export default function AddTabsList({ tabs, setTabs }) {
    const removeTab = useCallback(id=>{
        setTabs(
            tabs.filter(tab=>tab.id!=id)
        )
    }, [tabs, setTabs])

    return (
        <>
            <Label>{t.s('tabs')}</Label>

            {tabs.length ? (
                <Wrap className={'ui-ext-tabs-list'}>
                    {tabs.map(({ id, url, title, favIconUrl })=>(
                        <Item 
                            key={id}
                            title={title}>
                            <ItemIcon>{favIconUrl ? 
                                <img src={favIconUrl} /> :
                                <Cover 
                                    link={url}
                                    domain={getDomain(url)}
                                    view='simple' />
                            }</ItemIcon>
                            <ItemTitle>{title}</ItemTitle>
                            <ItemActions>
                                <Button variant='ghost' 
                                    title={t.s('remove')}
                                    onClick={()=>removeTab(id)}>
                                    <Icon name='trash' />
                                </Button>
                            </ItemActions>
                        </Item>
                    ))}
                </Wrap>
            ) : (
                <Alert variant='warning'>
                    {t.s('nothingFound')}
                </Alert>
            )}
        </>
    )
}